import { ConnectComponent } from '$views/components/utils/ConnectComponent'
import { LogoutView } from '$views/Logout/Logout.view'
import { LogoutPresenter } from '$views/Logout/Logout.presenter'

export const Logout = ConnectComponent(LogoutView, LogoutPresenter)



// WEBPACK FOOTER //
// ./src/views/Logout/index.ts